import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import { Box, Button, Popover, Stack, Typography } from '@mui/material';
import { Theme } from '@mui/material/styles';
import { Link } from 'react-router-dom';
import { makeStyles } from 'tss-react/mui';
import { settingsRoutes as routes } from '../../../routes';
import { UserInfo } from '../../../sic-lib/types/UserConfig';
import { useDialerIsReady, useDialerIsRegistered } from '../../../store/dialer';
import { useAppSelector } from '../../../store/hooks';
import { ButtonLogout } from '../../Shared/ButtonLogout';
import DisplayPhoneNumber from '../../Shared/DisplayPhoneNumber/DisplayPhoneNumber';
import { ButtonStopImpersonating } from '../../Support/ButtonStopImpersonating';
import { UserAvatar } from './UserAvatar';

interface ProfileBadgePopOverProps {
    user: UserInfo | undefined;
    anchorEl: HTMLElement | null;
    handleClose: () => void;
}

export const UserPopover = ({ user, anchorEl, handleClose }: ProfileBadgePopOverProps) => {
    const { classes } = useStyles();
    const open = Boolean(anchorEl);

    const phoneNumber = useAppSelector(state => state.user.dialerPhone);
    const isImpersonated = useAppSelector(state => state.user.isImpersonated);
    const clientId = useAppSelector(state => state.user.clientId);
    const dialerIsReady = useDialerIsReady();
    const dialerIsRegistered = useDialerIsRegistered();

    return (
        <Popover
            anchorEl={anchorEl}
            id="account-menu"
            open={open}
            onClose={handleClose}
            onClick={handleClose}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
        >
            <Stack
                direction="column"
                spacing={2}
                p={2}
                justifyContent="center"
                sx={{ minWidth: 250 }}
            >
                <Stack direction="row" spacing={2}>
                    <UserAvatar user={user} scale={3.5} tooltip={false} />
                    <Box>
                        <Typography variant="h6">
                            {user?.firstName} {user?.lastName}
                        </Typography>
                        <Typography variant="subtitle1">{user?.userName}</Typography>
                    </Box>
                </Stack>
                <Button
                    component={Link}
                    to={routes.setCreateEditUser(user?.userName)}
                    variant="text"
                    fullWidth
                >
                    User Settings
                </Button>
                <Stack direction="column" spacing={1} alignItems="center" justifyContent="center">
                    <Typography variant="subtitle2" textAlign="center">
                        My StayInContact Number
                    </Typography>
                    <DisplayPhoneNumber phoneNumber={phoneNumber} />
                    {dialerIsRegistered && dialerIsReady && (
                        <Typography variant="caption" textAlign="center">
                            In-Browser Calling Active
                        </Typography>
                    )}
                    {dialerIsRegistered && !dialerIsReady && (
                        <Typography variant="caption" textAlign="center">
                            In-Browser Calling Busy
                        </Typography>
                    )}
                    {!dialerIsRegistered && (
                        <Typography variant="caption" textAlign="center">
                            In-Browser Calling Not Available
                        </Typography>
                    )}
                </Stack>
                <ButtonLogout fullWidth startIcon={<ExitToAppIcon />} />
                {isImpersonated && (
                    <>
                        <Typography variant="subtitle1">ClientId: {clientId}</Typography>
                        <ButtonStopImpersonating fullWidth />
                    </>
                )}
            </Stack>
        </Popover>
    );
};

const useStyles = makeStyles()((theme: Theme) => ({}));
